<template>
    <!-- 对话框 -->
    <el-drawer title="订单信息" :visible.sync="show" :before-close="closeDialog" size="80%" @opened="openDrawer"
               class="order-detial-wrap" :show-close="false">

        <div v-loading="loading">

            <div class="steps" v-if="!loading">
                <el-steps :active="Number(stepsNum)" align-center>
                    <el-step title="新单" :description="order_details_time.order_time.YmdHis"></el-step>
                    <el-step title="已派单" :description="order_details_time.assign_time.YmdHis"></el-step>
                    <el-step title="已接单" :description="order_details_time.take_time.YmdHis"></el-step>
                    <el-step title="前往预约地" :description="order_details_time.go_way_time.YmdHis"></el-step>
                    <el-step title="到达预约地" :description="order_details_time.arrive_time.YmdHis"></el-step>
                    <el-step title="前往目的地" :description="order_details_time.start_time.YmdHis"></el-step>
                    <el-step title="到达目的地" :description="order_details_time.end_time.YmdHis"></el-step>
                    <el-step title="已结算" :description="order_details_time.pay_time.YmdHis"></el-step>
                </el-steps>
            </div>


            <div class="box">

                <div id="container_route" style="display: flex; justify-content: center; align-items: center;"></div>

                <div v-if="!loading" class="tabs-box">
                    <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs" type="card">


                        <el-tab-pane label="订单信息" name="order">

                            <div style="height: 100%; overflow-y: auto;">
                                <table style="width: 100%;" class="primary-table">
                                    <tr class="head">
                                        <td>类型</td>
                                        <td>值</td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>订单号</td>
                                        <td>{{ order_details.billno }}</td>
                                    </tr>

<!--                                    <tr class="even">-->
<!--                                        <td>跑腿类型</td>-->
<!--                                        <td>{{-->
<!--                                            order_details.legwork_order_type=='0'?'代取':order_details.legwork_order_type=='1'?'代送':-->
<!--                                            order_details.legwork_order_type=='2'?'代买':'其他'}}-->
<!--                                        </td>-->
<!--                                    </tr>-->


                                    <tr class="Odd">
                                        <td>收客户姓名</td>
                                        <td>{{ order_details.consumer_name }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>客户电话</td>
                                        <td>{{ order_details.consumer_phone }}</td>

                                    </tr>




                                    <tr class="Odd">
                                        <td>起点名称</td>
                                        <td>{{ order_details.start_name }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>终点名称</td>
                                        <td>{{ order_details.end_name }}</td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>下单时间</td>
                                        <td>{{ order_details.order_time.YmdHis }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>完成时间</td>
                                        <td>{{ order_details.end_time.YmdHis }}</td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>支付时间</td>
                                        <td>{{ order_details.pay_time.YmdHis }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>备注信息</td>
                                        <td>{{ order_details.remarks }}</td>
                                    </tr>


                                    <tr class="Odd">
                                        <td>支付方式</td>
                                        <td>{{ order_details.pay_mode.alias }}</td>
                                    </tr>
                                    <tr class="even">
                                        <td>支付通道</td>
                                        <td>{{ order_details.pay_channel.alias }}</td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>客服名称</td>
                                        <td>{{ order_details.admin_name }}</td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>司机拍照</td>
                                        <td>

                                            <div style="display: block" v-for="(item,index) in order_img">
                                                <el-image
                                                        style="width: 100px; height: 100px"
                                                        :src="item"
                                                        :preview-src-list="order_img">
                                                </el-image>
                                            </div>

                                        </td>
                                    </tr>



                                </table>

                            </div>


                        </el-tab-pane>



<!--                        `starting_price`  '起步价',-->
<!--                        `kilometre_money`  '按公里增加费用',-->
<!--                        `weather_price` '恶劣天气增加计费',-->
<!--                        `weight`  '跑腿带货重量',-->
<!--                        `weight_money`  '按重量增加金额',-->
<!--                        `real_price` '物品实际价值',-->
<!--                        `safe_fee`  '收取保费',-->
<!--                        `indemnify`  '最多可赔付',-->
<!--                        `bonus`  '奖励金，无人接单时，可以加价找司机',-->
<!--                        `amount`  '实际金额',-->
<!--                        `finish_amount`  '实收金额',-->


                        <el-tab-pane label="付款信息" name="payment">

                            <p v-if="order_synchronization == null"
                               style="font-size: 16px; text-align: center; margin-top: 20px;">
                                暂无付款信息
                            </p>


                            <div style="max-height: 100%;overflow-y: auto;" v-else>

                                <table style="width: 100%;" class="primary-table">
                                    <tr class="head">
                                        <td width="240px">款项名</td>
                                        <td>金额</td>
                                    </tr>

                                    <tr class="Odd">
                                        <td>实际金额</td>
                                        <td><span style="color: #f90;">
                                           {{ order_details.amount }}
                                        </span>元
                                        </td>
                                    </tr>

                                    <tr class="even">
                                        <td>实收金额</td>
                                        <td>
                                            <span style="color: #f90;">
                                                {{ order_details.finish_amount }}
                                            </span>元
                                        </td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>退款金额</td>
                                        <td><span style="color: #f90;">
                                           {{ order_details.refund_fee }}
                                        </span>元
                                        </td>
                                    </tr>

                                    <tr class="even">
                                        <td>工时费</td>
                                        <td>
                                            <span style="color: #f90;">
                                                {{ order_details.refund_money }}
                                            </span>元
                                        </td>
                                    </tr>
                                    <tr class="Odd">
                                        <td>司机收入</td>
                                        <td><span style="color: #f90;">
                                           {{ order_details.driver_amount }}
                                        </span>元
                                        </td>
                                    </tr>

                                </table>


                            </div>


                        </el-tab-pane>

<!--                        <el-tab-pane label="抢单记录" name="grabbing">-->

<!--                            &lt;!&ndash; 表格 &ndash;&gt;-->
<!--                            <el-table :data="grabbingData" style="width: 100%" ref="multipleTable"-->
<!--                                      header-cell-class-name="table-header">-->






<!--                                <el-table-column prop="order_code" label="系统编号">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        {{scope.row.legwork_order_code}}-->
<!--                                    </template>-->
<!--                                </el-table-column>-->



<!--                                <el-table-column prop="time.YmdHis" label="下单时间">-->
<!--                                </el-table-column>-->

<!--                                <el-table-column prop="type.alias" label="说明">-->
<!--                                </el-table-column>-->



<!--                            </el-table>-->

<!--                            &lt;!&ndash; 分页组件 &ndash;&gt;-->
<!--                            <div style="text-align: right;">-->
<!--                                <el-pagination layout="prev, pager, next" :total="result_data_children.count"-->
<!--                                               @current-change="pages_function">-->
<!--                                </el-pagination>-->
<!--                            </div>-->

<!--                        </el-tab-pane>-->



<!--                        <el-tab-pane label="跟踪记录" name="record">-->

<!--                            <p v-if="order_track_lists.length == 0 || order_track_lists == null"-->
<!--                               style="font-size: 16px; text-align: center; margin-top: 20px;">暂无跟踪信息-->


<!--                            </p>-->


<!--                            <div style="max-height: 100%;overflow-y: auto;" v-else>-->

<!--                                <table style="width: 100%;" class="primary-table">-->
<!--                                    <tr class="head">-->
<!--                                        <td>时间</td>-->
<!--                                        <td>备注</td>-->
<!--                                        <td>端口</td>-->
<!--                                        <td>管理员</td>-->
<!--                                    </tr>-->
<!--                                    <tr :class="{ 'Odd': index%2 != 0 , 'even': index%2 == 0 }"-->
<!--                                        v-for="(item, index) in order_track_lists.result" :key="index">-->
<!--                                        <td>{{ item.time.YmdHis }}</td>-->
<!--                                        <td>{{ item.remarks }}</td>-->
<!--                                        <td>{{ item.port.alias }}</td>-->
<!--                                        <td>{{ item.admin_name }}</td>-->
<!--                                    </tr>-->


<!--                                </table>-->
<!--                            </div>-->

<!--                        </el-tab-pane>-->

<!--                        <el-tab-pane label="轨迹列表" name="track">-->
<!--                            &lt;!&ndash; 兼容旧版本数据 &ndash;&gt;-->
<!--                            <p v-if="order_synchronization == null || order_synchronization == undefined || order_synchronization.driver_go_coordinate == undefined || order_synchronization.driver_go_coordinate.val.length == 0"-->
<!--                               style="font-size: 16px; text-align: center; margin-top: 20px;">暂无轨迹信息-->
<!--                            </p>-->

<!--                            <div style="max-height: 100%;overflow-y: auto;" v-else>-->
<!--                                <table style="width: 100%;" class="primary-table">-->
<!--                                    <tr class="head">-->
<!--                                        <td>定位时间</td>-->
<!--                                        <td>类型</td>-->
<!--                                        <td>精度</td>-->
<!--                                    </tr>-->
<!--                                    <tr :class="{ 'Odd': index%2 != 0 , 'even': index%2 == 0 }"-->
<!--                                        v-for="(item, index) in order_synchronization.driver_go_coordinate.val"-->
<!--                                        @mouseover="tableHover(item.lng,item.lat,item.accuracy,item.time.YmdHis,item.location_type)"-->
<!--                                        @mouseout="tableLeave">-->
<!--                                        <td>{{ item.time.YmdHis }}</td>-->
<!--                                        <td>{{ item.location_type }}</td>-->
<!--                                        <td>{{ item.accuracy }}</td>-->
<!--                                    </tr>-->
<!--                                </table>-->
<!--                            </div>-->

<!--                        </el-tab-pane>-->

<!--                        <el-tab-pane label="异常记录" name="difference">-->

<!--                            <p v-if="order_difference_lists == null || order_difference_lists.length == 0"-->
<!--                               style="font-size: 16px; text-align: center; margin-top: 20px;">暂无异常信息-->
<!--                            </p>-->

<!--                            <div style="max-height: 100%;overflow-y: auto;" v-else>-->
<!--                                <table style="width: 100%;" class="primary-table">-->
<!--                                    <tr class="head">-->
<!--                                        <td>订单编号</td>-->
<!--                                        <td>时间</td>-->
<!--                                        <td>备注</td>-->
<!--                                    </tr>-->
<!--                                    <tr :class="{ 'Odd': index%2 != 0 , 'even': index%2 == 0 }"-->
<!--                                        v-for="(item, index) in order_difference_lists.result">-->
<!--                                        <td>{{ item.order_code }}</td>-->
<!--                                        <td>{{ item.time.YmdHis }}</td>-->
<!--                                        <td>{{ item.remarks }}</td>-->
<!--                                    </tr>-->
<!--                                </table>-->
<!--                            </div>-->

<!--                        </el-tab-pane>-->


                    </el-tabs>
                </div>

            </div>

        </div>

        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: start;height: 32px;margin: 20px 0;padding-left: 20px"
             v-if="!loading">
            <el-button @click="markAnimation">开始</el-button>
            <el-button @click="resetAnimation">重置</el-button>
            <el-button @click="rulerOpen">测距</el-button>
        </div>

    </el-drawer>
</template>

<script>
    import bus from '../../common/bus.js';

    var _this, map, measureTool, marker, city_name, driverSimulation, passedPolyline, ruler1, temporaryMarker, temporaryLabel,
        passedPolyline, path, leagueMarker;

    export default {
        props: {
            'isShow': Boolean,
            'data': '',
            'status': '',
            'showConsumer': Boolean
        },
        watch: {

            isShow(newData, oldData) {

                console.log(_this.showConsumer);
                _this.show = true;

                _this.$nextTick(function() {

                    _this.order_details = [];
                    _this.order_synchronization = [];
                    _this.order_track_lists = [];


                    _this.order_status = _this.status;


                    _this.search_data_children.inspection_order_code = _this.data;
                    _this.grabbingInit();
                });


            }
        },
        data() {
            return {


                show: false,

                loading: true,

                driver: [],

                driverMarks_status: [],

                // 骑行路线坐标组
                // riding_coordinate: [],

                // 行程坐标点数据
                coordinate_array: [],
                coordinate_array_true: [],

                grabbingData:[],

                stepsNum: 0,

                activeName: 'order',

                appraise_data: [],

                order_status: '',

                order_details: [],

                order_details_time: {
                    order_time: {
                        YmdHis: '未设置'
                    },
                    assign_time: {
                        YmdHis: '未设置'
                    },
                    take_time: {
                        YmdHis: '未设置'
                    },
                    go_way_time: {
                        YmdHis: '未设置'
                    },
                    arrive_time: {
                        YmdHis: '未设置'
                    },
                    start_time: {
                        YmdHis: '未设置'
                    },
                    end_time: {
                        YmdHis: '未设置'
                    },
                    pay_time: {
                        YmdHis: '未设置'
                    }
                },

                order_synchronization: [],
                order_difference_lists: [],
                order_track_lists: [],

                search_data_children: {
                    inspection_order_code: '',
                    page: 1,
                    limit: 10
                },

                result_data_children:[],



                order_img:[]

            };
        },
        created() {

            _this = this;


        },
        methods: {

            grabbingInit() {

                _this.$post(
                    '/Inspectionline/inspectionOrderRobLists',
                    _this.search_data_children
                )
                    .then(res => {

                        _this.result_data_children = res;

                        _this.grabbingData = res.data;

                    }).catch((err) => {

                })
            },

            //翻页组件的回调
            pages_function(val) {
                _this.search_data_children.page = val;

                _this.grabbingInit();
            },


            // 选项卡点击事件
            handleClick(tab, event) {

                // console.log(tab, event);

            },

            openDrawer() {

                _this.order_img = []

                _this.$post(
                    '/Inspectionline/getOrderDetails', {
                        inspection_order_code: _this.data,
                        coordinate: '1',
                        synchronization: '1',
                        order_track: '1',
                        order_difference: '1'

                    }
                )
                    .then(res => {

                        _this.order_details = res.data.order_details;

                        _this.order_synchronization = res.data.order_synchronization;

                        for(let i=0;i<res.data.order_img.length;i++){
                            if(res.data.order_img[i].url!=''){
                                _this.order_img.push(res.data.order_img[i].url)
                            }

                        }


                        // if (res.data.order_synchronization !== null && typeof (res.data.order_synchronization
                        //     .driver_go_coordinate) != 'undefined') {
                        //
                        //     _this.riding_coordinate = res.data.order_synchronization.driver_go_coordinate.val;
                        //
                        // } else {
                        //
                        //     _this.riding_coordinate = [];
                        //
                        // }


                        if (res.data.order_synchronization !== null && typeof (res.data.order_synchronization
                            .order_go_coordinate) !== 'undefined') {


                            _this.coordinate_array = res.data.order_synchronization.order_go_coordinate.val;

                        } else {

                            _this.coordinate_array = [];


                        }


                        _this.order_difference_lists = (res.data.order_difference_lists !== null && typeof (res.data
                            .order_difference_lists) !== 'undefined') ? res.data.order_difference_lists : [];

                        _this.order_track_lists = (res.data.order_track_lists !== null && typeof (res.data.order_track_lists) !==
                            'undefined') ? res.data.order_track_lists : [];

                        console.log(_this.order_details.pay_time);

                        if (typeof (_this.order_details.pay_time) !== 'undefined') {

                            _this.order_details_time.pay_time.YmdHis = _this.order_details.pay_time.YmdHis;

                        }
                        if (typeof (_this.order_details.end_time) !== 'undefined') {

                            _this.order_details_time.end_time.YmdHis = _this.order_details.end_time.YmdHis;

                        }
                        if (typeof (_this.order_details.start_time) !== 'undefined') {

                            _this.order_details_time.start_time.YmdHis = _this.order_details.start_time.YmdHis;

                        }
                        if (typeof (_this.order_details.arrive_time) !== 'undefined') {

                            _this.order_details_time.arrive_time.YmdHis = _this.order_details.arrive_time.YmdHis;

                        }
                        if (typeof (_this.order_details.go_way_time) !== 'undefined') {

                            _this.order_details_time.go_way_time.YmdHis = _this.order_details.go_way_time.YmdHis;

                        }
                        if (typeof (_this.order_details.take_time) !== 'undefined') {

                            _this.order_details_time.take_time.YmdHis = _this.order_details.take_time.YmdHis;

                        }
                        if (typeof (_this.order_details.assign_time) !== 'undefined') {

                            _this.order_details_time.assign_time.YmdHis = _this.order_details.assign_time.YmdHis;

                        }
                        if (typeof (_this.order_details.order_time) !== 'undefined') {

                            _this.order_details_time.order_time.YmdHis = _this.order_details.order_time.YmdHis;

                        }


                        if (typeof (_this.order_details.pay_time.YmdHis) !== 'undefined' && _this.order_details.pay_time
                            .YmdHis !== '未设置') {

                            _this.stepsNum = 8;

                        } else if (typeof (_this.order_details.end_time.YmdHis) !== 'undefined' && _this.order_details
                            .end_time
                            .YmdHis !== '未设置') {

                            _this.stepsNum = 7;

                        } else if (typeof (_this.order_details.start_time.YmdHis) !== 'undefined' && _this.order_details
                            .start_time.YmdHis !== '未设置') {

                            _this.stepsNum = 6;

                        } else if (typeof (_this.order_details.arrive_time.YmdHis) !== 'undefined' && _this.order_details
                            .arrive_time.YmdHis !== '未设置') {

                            _this.stepsNum = 5;

                        } else if (typeof (_this.order_details.go_way_time.YmdHis) !== 'undefined' && _this.order_details
                            .go_way_time.YmdHis !== '未设置') {

                            _this.stepsNum = 4;

                        } else if (typeof (_this.order_details.take_time.YmdHis) !== 'undefined' && _this.order_details
                            .take_time
                            .YmdHis !== '未设置') {

                            _this.stepsNum = 3;

                        } else if (typeof (_this.order_details.assign_time) !== 'undefined' && typeof (_this.order_details
                            .assign_time.YmdHis) !== 'undefined' && _this.order_details.assign_time.YmdHis !== '未设置') {

                            _this.stepsNum = 2;

                        } else if (typeof (_this.order_details.order_time.YmdHis) !== 'undefined' && _this.order_details
                            .order_time.YmdHis !== '未设置') {


                            _this.stepsNum = 1;

                        }


                        // 地图初始化
                        map = new TMap.Map('container_route', {
                            zoom: 11, //初始地图级别
                            viewMode: '2D'
                        });

                        // 创建测量工具
                        measureTool = new TMap.tools.MeasureTool({
                            map: map,
                        });


                        // 联盟商家坐标
                        _this.$post(
                            '/admin.php/Business/ipcShoppingLists', {
                                page: 1,
                                limit: 10,
                                shop_name: '',
                                city_code: ''
                            }).then(res => {
                            if (res.data.length > 0) {

                                for (let i = 0; i < res.data.length; i++) {

                                    leagueMarker = new TMap.MultiMarker({
                                        map: map,  //指定地图容器
                                        //样式定义
                                        styles: {
                                            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                                            "myStyle": new TMap.MarkerStyle({
                                                "width": 25,  // 点标记样式宽度（像素）
                                                "height": 34, // 点标记样式高度（像素）
                                                "src": require('@/assets/League.png'),  //图片路径
                                                "offset": { x: -13, y: -30 }
                                            })
                                        },
                                        //点标记数据数组
                                        geometries: [{
                                            "id": res.data[i].id,   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                                            "styleId": 'myStyle',  //指定样式id
                                            "position": new TMap.LatLng(res.data[i].lat, res.data[i].lng),  //点标记坐标位置
                                            "properties": {//自定义属性
                                                "title": "marker1"
                                            }
                                        }
                                        ]

                                    });

                                }

                            }


                        }).catch((err) => {

                        });


                        // 将地图绑定点击事件   点击关闭信息窗口
                        map.on('click', this.closePop);


                        // 如果没有行程坐标数据
                        if (_this.order_synchronization == null) {

                            var loginCityName = JSON.parse(localStorage.getItem('login')).city.name;

                            var x = loginCityName.indexOf('/');

                            for (var i = 0; i < 1; i++) {
                                x = loginCityName.indexOf('/', x + 1);
                            }

                            // console.log(x);

                            // 如果为市级
                            if (x < 0) {

                                // 截取城市名称 如:XXXX / 截取字段
                                var city_name = loginCityName.slice(loginCityName.indexOf('/') + 2);


                            } else {

                                // 截取城市名称 如:XXXX / XXXX / 截取字段
                                var city_name = loginCityName.slice(x + 2);

                            }

                            // 根据城市决定地图中心点
                            // map.setCity(city_name, function(params) {

                            // });

                        }




                        // 请求城市列表接口   获取围栏信息
                        this.$post(
                            '/admin.php/city/getCityDetails'
                        )
                            .then(res => {
                                var center = res.data.center;
                                console.log(center);
                                const [lng, lat] = center.split(',').map(Number);
                                map.setCenter(new TMap.LatLng(lat, lng));

                                if (JSON.parse(res.data.free_area_coordinate_array) != null && res.data.free_area_coordinate_array != '[]' && res.data.free_area_coordinate_array != '') {
                                    let arr = [];
                                    var path1 = arr.concat(JSON.parse(res.data.free_area_coordinate_array));
                                    path1.push(JSON.parse(res.data.free_area_coordinate_array)[0]);
                                    var polygonPath = path1.map(coord => new TMap.LatLng(coord[1], coord[0]));

                                }

                                if (JSON.parse(res.data.far_area_coordinate_array) != null && res.data.far_area_coordinate_array != '[]' && res.data.far_area_coordinate_array != '') {
                                    let arr = [];
                                    var path2 = arr.concat(JSON.parse(res.data.far_area_coordinate_array));
                                    path2.push(JSON.parse(res.data.far_area_coordinate_array)[0]);
                                    var polygonPath2 = path2.map(coord => new TMap.LatLng(coord[1], coord[0]));

                                }
                                if (JSON.parse(res.data.effective_area_coordinate_array) != null && res.data.effective_area_coordinate_array != '[]' && res.data.effective_area_coordinate_array != '') {
                                    let arr = [];
                                    var path3 = arr.concat(JSON.parse(res.data.effective_area_coordinate_array));
                                    path3.push(JSON.parse(res.data.effective_area_coordinate_array)[0]);
                                    var polygonPath3 = path3.map(coord => new TMap.LatLng(coord[1], coord[0]));
                                }

                                if (path1) {
                                    var polyline1 = new TMap.MultiPolyline({
                                        map: map,
                                        //折线样式定义
                                        styles: {
                                            'style_green': new TMap.PolylineStyle({
                                                'color': '#008000', //线填充色
                                                'width': 6, //折线宽度
                                                'lineCap': 'round' //线端头方式
                                            }),
                                        },
                                        //折线数据定义
                                        geometries: [
                                            {//第1条线
                                                'id': 'pl_1',//折线唯一标识，删除时使用
                                                'styleId': 'style_green',//绑定样式名
                                                'paths': polygonPath
                                            }
                                        ],
                                    });

                                    path1 = [];
                                }

                                if (path2) {

                                    var polyline2 = new TMap.MultiPolyline({
                                        map: map,
                                        //折线样式定义
                                        styles: {
                                            'style_pink': new TMap.PolylineStyle({
                                                'color': '#FF69B4', //线填充色
                                                'width': 6, //折线宽度
                                                'lineCap': 'round' //线端头方式
                                            }),
                                        },
                                        //折线数据定义
                                        geometries: [
                                            {//第1条线
                                                'id': 'pl_2',//折线唯一标识，删除时使用
                                                'styleId': 'style_pink',//绑定样式名
                                                'paths': polygonPath2
                                            }
                                        ],
                                    });
                                    path2 = [];

                                }

                                if (path3) {

                                    var polyline3 = new TMap.MultiPolyline({
                                        map: map,
                                        //折线样式定义
                                        styles: {
                                            'style_black': new TMap.PolylineStyle({
                                                'color': '#000000', //线填充色
                                                'width': 6, //折线宽度
                                                'lineCap': 'round' //线端头方式
                                            })
                                        },
                                        //折线数据定义
                                        geometries: [
                                            {//第1条线
                                                'id': 'pl_3',//折线唯一标识，删除时使用
                                                'styleId': 'style_black',//绑定样式名
                                                'paths': polygonPath3
                                            }
                                        ],
                                    });
                                    path3 = [];

                                }


                            }).catch((err) => {

                        });


                        var path_riding = [];

                        // if (_this.riding_coordinate.length != 0) {
                        //     // 如果存在骑行路径
                        //
                        //     // for (let index = 0; index < _this.riding_coordinate.length; index++) {
                        //     //
                        //     //     path_riding.push([_this.riding_coordinate[index].lng, _this.riding_coordinate[index].lat]);
                        //     //
                        //     // }
                        //
                        //
                        //     // // 骑行路线
                        //     // var ridingPolyline = new AMap.Polyline({
                        //     //     path: path_riding,
                        //     //     isOutline: true,
                        //     //     outlineColor: '#ffeeff',
                        //     //     borderWeight: 0,
                        //     //     strokeColor: '#FD8B7B',
                        //     //     strokeOpacity: 1,
                        //     //     strokeWeight: 6,
                        //     //     bubble: true,
                        //     //     // 折线样式还支持 'dashed'
                        //     //     strokeStyle: 'solid',
                        //     //     // strokeStyle是dashed时有效
                        //     //     strokeDasharray: [10, 5],
                        //     //     lineJoin: 'round',
                        //     //     lineCap: 'round',
                        //     //     zIndex: 50
                        //     // });
                        //     //
                        //     // ridingPolyline.setMap(map);
                        //
                        //
                        //     // var markerContent = '' +
                        //     //     '<div class="custom-content-marker">' +
                        //     //     '   <span class="iconfont icon-zihangche"></span>' +
                        //     //     '</div>';
                        //     //
                        //     // // 将 icon 传入 marker
                        //     // var ridingStartMarker = new AMap.Marker({
                        //     //     position: new AMap.LngLat(_this.riding_coordinate[0].lng, _this.riding_coordinate[0].lat),
                        //     //     content: markerContent,
                        //     //     offset: new AMap.Pixel(-30, -55)
                        //     // });
                        //     //
                        //     // // 将 markers 添加到地图
                        //     // map.add(ridingStartMarker);
                        //
                        //
                        // }


                        var path_coordinate = [];
                        var polygonPath4 = [];

                        if (_this.coordinate_array.length != 0) {

                            for (let index = 0; index < _this.coordinate_array.length; index++) {

                                path_coordinate.push([_this.coordinate_array[index].lng, _this.coordinate_array[index].lat]);
                                polygonPath4 = path_coordinate.map(coord => new TMap.LatLng(coord[1], coord[0]));

                            }

                            _this.coordinate_array_true = path_coordinate;


                            var polyline = new TMap.MultiPolyline({
                                map: map,
                                //折线样式定义
                                styles: {
                                    'style_blue': new TMap.PolylineStyle({
                                        'color': '#409EFF', //线填充色
                                        'width': 6, //折线宽度
                                        'borderWidth': 0, //边线宽度
                                        'borderColor': '#ffeeff', //边线颜色
                                        'lineCap': 'round' //线端头方式
                                    })
                                },
                                //折线数据定义
                                geometries: [
                                    {//第1条线
                                        'id': 'pl_riding',//折线唯一标识，删除时使用
                                        'styleId': 'style_blue',//绑定样式名
                                        'paths': polygonPath4
                                    }
                                ],
                            })
                            // 缩放地图到合适的视野级别
                            // map.setFitView([polyline], true, [50, 50, 50, 50], 15);


                            // 创建起点标记
                            var startMarker = new TMap.MultiMarker({
                                map: map,
                                styles: {
                                    "startStyle": new TMap.MarkerStyle({
                                        "width": 25,
                                        "height": 34,
                                        "src": '//mapapi.qq.com/web/lbs/javascriptGL/demo/img/start.png',
                                        "offset": { x: -13, y: -30 },
                                        "zIndex": 999,
                                        "isStopPropagation": true,
                                    })
                                },
                                geometries: [{
                                    "id": "start_marker",
                                    "styleId": "startStyle",
                                    "position": new TMap.LatLng( _this.coordinate_array[0].lat,  _this.coordinate_array[0].lng),
                                    "draggable": true,
                                    "properties": {
                                        "title": "起点"
                                    }
                                }]
                            });


                            // 添加终点标记
                            // 创建一个 Icon
                            var endMarker =new TMap.MultiMarker({
                                map: map,
                                styles: {
                                    "endStyle": new TMap.MarkerStyle({
                                        "width": 25,
                                        "height": 34,
                                        "src": '//mapapi.qq.com/web/lbs/javascriptGL/demo/img/end.png',
                                        "offset": { x: -13, y: -30 },
                                        "zIndex": 999,
                                        "isStopPropagation": true,
                                    })
                                },
                                geometries: [{
                                    "id": "end_marker",
                                    "styleId": "endStyle",
                                    "position": new TMap.LatLng( _this.coordinate_array[_this.coordinate_array.length - 1].lat, _this.coordinate_array[_this.coordinate_array.length - 1].lng),
                                    "draggable": true,
                                    "properties": {
                                        "title": "终点"
                                    }
                                }]
                            })


                            // 模拟的司机标记
                            driverSimulation = new TMap.MultiMarker({
                                map,
                                styles: { //样式设置
                                    'car-down': new TMap.MarkerStyle({
                                    // 'anchor': {   //图片中心的像素位置（小车会保持车头朝前，会以中心位置进行转向）
                                    //     x: 20,y: 20,
                                    // },
                                    'width': 26,
                                    'height': 52,
                                    'faceTo': 'map',  //取’map’让小车贴于地面，faceTo取值说明请见下文图示
                                    'rotate': 180,    //初始小车朝向（正北0度，逆时针一周为360度，180为正南）
                                    'src': 'https://a.amap.com/jsapi_demos/static/demo-center-v2/car.png',   //小车图片（图中小车车头向上，即正北0度）
                                    })
                                },
                                geometries: [{    //小车marker的位置信息
                                    id: 'car',      //因MultiMarker支持包含多个点标记，因此要给小车一个id
                                    styleId: 'car-down',    //绑定样式
                                    position: new TMap.LatLng(Number(_this.coordinate_array[0].lat), Number(_this.coordinate_array[0].lng)),//初始坐标位置
                                }]
                            });

                        console.log('进来了========================================');



                        }
                         _this.loading = false;
                    }).catch(res => {

                });


            },

            // 计算订单时长方法
            getTimes(startTime, endTime) {

                if (startTime === '未设置') {
                    return startTime;
                }

                if (endTime === '未设置') {
                    return endTime;
                }
                let startTime1 = startTime.replace(/\-/g, '/');
                let endTime1 = endTime.replace(/\-/g, '/');

                let date1 = new Date(startTime1);    //开始时间
                let date2 = new Date(endTime1);    //结束时间
                let date3 = date1.getTime() - date2.getTime(); //时间差秒


                let hours = Math.floor(date3 / (3600 * 1000));

                //计算相差分钟数
                let leave1 = date3 % (3600 * 1000);        //计算小时数后剩余的毫秒数
                let minutes = Math.floor(leave1 / (60 * 1000));

                //计算相差秒数
                let leave2 = leave1 % (60 * 1000);     //计算分钟数后剩余的毫秒数
                let seconds = Math.round(leave2 / 1000);

                let string = hours + '时' + minutes + '分' + seconds + '秒';

                return string;
            },

            tableHover(lng, lat, accuracy, time, type) {

                _this.tableLeave();

                var temporaryIcon = new TMap.MultiMarker({
                    map: map,
                    styles: {
                        "temporaryStyle": new TMap.MarkerStyle({
                            "width": 25,
                            "height": 34,
                            "src": '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                            "offset": { x: -13, y: -30 },
                            "zIndex": 999,
                            "isStopPropagation": true,
                        })
                    },
                    geometries: [{
                        "id": "temporary_marker",
                        "styleId": "temporaryStyle",
                        "position": new TMap.LatLng(Number(lat), Number(lng)),
                        "draggable": true,
                        "properties": {
                            "title": "临时点"
                        }
                    }]
                });


                if (lng == undefined) {
                    lng = '';
                }
                if (lat == undefined) {
                    lat = '';
                }
                if (time == undefined) {
                    time = '';
                }
                if (type == undefined) {
                    type = '';
                }
                if (accuracy == undefined) {
                    accuracy = '';
                }


                temporaryLabel = new TMap.InfoWindow({
                    map: map,
                    position: new TMap.LatLng(Number(lat), Number(lng)),
                    content: '<div style="width: 200px;">' +
                        '<h5 style="padding: 5px 0;text-align: center;background-color: #409EFF; color:#fff">轨迹详情</h5>' +
                        '<div style="padding: 5px;background-color: #fff;">' +
                        '<p>经度:' + lng + '</p>' +
                        '<p>纬度:' + lat + '</p>' +
                        '<p>定位时间:' + time + '</p>' +
                        '<p>类型:' + type + '</p>' +
                        '<p>精度:' + accuracy + '</p>' +
                        '</div>' +
                        '</div>',
                    offset: { x: 0, y: -30 },
                });


            },


            tableLeave() {


                if (temporaryMarker) {

                    temporaryMarker.setGeometries([]);

                }


                if (temporaryLabel) {
                    temporaryLabel.close();
                }


            },

            // 测距按钮
            rulerOpen() {

                 measureTool.measureDistance().then((res) => {
                    //测量结束，将结果显示到页中
                    // alert('测量结果为：' + res.totalDistance + '米');
                });

            },

            // 开始按钮
            markAnimation() {
                if (passedPolyline) {
                    passedPolyline.remove('pl_passed')
                }
                path = [];

                if (_this.coordinate_array_true.length != 0) {
                for (let index = 0; index < _this.coordinate_array_true.length; index++) {


                    let lng = _this.coordinate_array_true[index][0];
                    let lat = _this.coordinate_array_true[index][1];
                    path.push(new TMap.LatLng(Number(lat), Number(lng)));

                }

                }
                console.log(path, 'path');
                // 车已走过的线
                passedPolyline = new TMap.MultiPolyline({
                    map,
                    styles: { //样式设置
                        'car-down': new TMap.PolylineStyle({
                            color: '#AF5', //线颜色
                            width: 6, //线宽
                            isStopPropagation: true
                        })
                    },
                    geometries: [{
                        id: 'pl_passed',
                        style: 'car-down',
                        paths: path
                    }]
                });


                driverSimulation.moveAlong(
                    {
                        car: {
                            path: path,
                            speed: 500,
                        },
                    },
                    {
                        autoRotation: true,
                    }
                );

                driverSimulation.on('moving', function (e) {

                    var passedLatLngs = e.car && e.car.passedLatLngs;
                    if (passedLatLngs) {
                    // 使用路线擦除接口 eraseTo, https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocVector
                    passedPolyline.eraseTo(
                        'pl_passed',
                        passedLatLngs.length - 1,
                        passedLatLngs[passedLatLngs.length - 1]
                    );
                    }

                });

                // driverSimulation.moveAlong(path, 500);
            },

            // 重置按钮
            resetAnimation() {
                driverSimulation.resumeMove();

                // 清除车已走过的线
                if (passedPolyline) {
                    passedPolyline.remove('pl_passed');
                }

                // driverSimulation.moveAlong(path, 500);
                driverSimulation.stopMove();
                driverSimulation.setGeometries([
                {
                    id: 'car',      //因MultiMarker支持包含多个点标记，因此要给小车一个id
                    styleId: 'car-down',    //绑定样式
                    position: new TMap.LatLng(Number(_this.coordinate_array[0].lat), Number(_this.coordinate_array[0].lng)),//初始坐标位置
                }
                ]);
            },

            // 管理司机信息窗口方法
            closePop() {
                // 遍历关闭信息窗口
                for (const key in _this.driverMarks_status) {
                    _this.driverMarks_status[key].close();
                }

            },

            // 关闭方法
            closeDialog() {

                _this.show = false;

                _this.$nextTick(function() {

                    _this.driver = [];

                    _this.driverMarks_status = [];

                    _this.coordinate_array = [];

                    _this.coordinate_array_true = [];

                    _this.order_synchronization = [];

                    _this.order_difference_lists = [];

                    _this.order_track_lists = [];

                    _this.appraise_data = [];

                    _this.order_details = [];

                    _this.loading = true;

                    map && map.destroy();

                });


            }


        }
    };
</script>

<style scoped>
    /* 高德地图css */
    @import 'https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css';
    @import 'https://a.amap.com/jsapi_demos/static/demo-center/css/prety-json.css';

    #container_route {
        height: 137px;
        height: 100%;
        width: 50%;
    }

    .steps {
        box-sizing: border-box;
        padding: 20px 50px 0;
        box-sizing: border-box;
        font-size: 12px;
        margin-bottom: 20px;
    }

    .box {
        height: calc(100vh - 350px);
        margin-left: 20px;
        display: flex;
        justify-content: space-around;
    }

    .tabs-item {
        margin-top: 20px;
    }

    .tabs-item div {
        margin: 20px 0;
    }

    .tabs-item div span {
        font-size: 16px;
        font-weight: 400;
    }

    .tabs-box {
        width: 50%;
        padding: 0 16px;
        height: calc(100vh - 350px);
    }
</style>
<style>
    .iconfont.icon-zihangche {
        font-size: 60px !important;
    }

    .iconfont.icon-zihangche::before {
        color: #00b9da !important;

    }

    .tabs-box .tabs {
        height: 100%;
    }

    .tabs-box .el-tabs__content {
        height: 90%;
        overflow: auto;
    }

    .order-detial-wrap #el-drawer__title > span {
        font-size: 18px;
        font-family: 'Microsoft YaHei';
        font-weight: 600;
        color: #222;
        line-height: 21px;
    }

    .order-detial-wrap .el-tabs--card > .el-tabs__header {
        border-bottom: 1px solid #E4E7ED !important;
    }

    .order-detial-wrap .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
        border-bottom-color: #FFF !important;
        border-left: 1px solid rgb(228, 231, 237) !important;
        border-right: 1px solid rgb(228, 231, 237) !important;
        border-top: 1px solid rgb(228, 231, 237) !important;
    }

    .order-detial-wrap .el-tabs--card > .el-tabs__header .el-tabs__item {
        border-bottom: 1px solid transparent;
    }


    .primary-table {

        margin-top: 40px;
        padding: 10px;

    }

    .primary-table,
    .primary-table th,
    .primary-table td {
        border: none;
    }

    .primary-table tr {
        border: 1px solid #ccc;
        transition: .5s;

    }

    .primary-table td {
        font-size: 12px;
        color: #333;
        padding: 10px;
    }

    .even td,
    .Odd td {
        font-size: 14px;
        font-weight: 400;
    }

    .even {
        background-color: #f5f7fa;
    }

    .head {
        background-color: #eff2f7;
    }

    .primary-table tr:hover {
        background-color: #b4d2f4;
    }
</style>
